import { render, staticRenderFns } from "./delivery_address_list.vue?vue&type=template&id=45da7ee2"
import script from "./delivery_address_list.vue?vue&type=script&lang=js"
export * from "./delivery_address_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports